import React from "react";
import { Card, Row, Col, Statistic, Divider, Skeleton } from "antd";

const StatsPanel = ({ filteredOrgCoords, totals, orgCoords, filtering }) => {
  return (
    <Card title="Statistiche" size="small" style={{ marginBottom: '16px' }}>
      {filtering ? (
        // Mostra skeleton durante il filtraggio
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : (
        // Contenuto normale quando non è in filtraggio
        <>
          <Statistic 
            title="Visualizzati" 
            value={filteredOrgCoords.length} 
            suffix={`/ ${totals.all} totali`}
            style={{ marginBottom: '16px' }}
          />
          
          <Divider orientation="left" style={{ margin: '8px 0' }}>Attivi</Divider>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Statistic 
                title="Production" 
                value={orgCoords.filter(coord => 
                  coord.org_pointer.stato === "attiva" && 
                  coord.org_pointer.tipo_istanza === "production"
                ).length}
                valueStyle={{ fontSize: '18px' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Free" 
                value={orgCoords.filter(coord => 
                  coord.org_pointer.stato === "attiva" && 
                  coord.org_pointer.tipo_istanza === "free"
                ).length}
                valueStyle={{ fontSize: '18px' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Demo" 
                value={orgCoords.filter(coord => 
                  coord.org_pointer.stato === "attiva" && 
                  coord.org_pointer.tipo_istanza === "demo"
                ).length}
                valueStyle={{ fontSize: '18px' }}
              />
            </Col>
          </Row>
          
          <Divider orientation="left" style={{ margin: '8px 0' }}>Disattivi</Divider>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Statistic 
                title="Production" 
                value={orgCoords.filter(coord => 
                  coord.org_pointer.stato === "disattiva" && 
                  coord.org_pointer.tipo_istanza === "production"
                ).length}
                valueStyle={{ fontSize: '18px' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Free" 
                value={orgCoords.filter(coord => 
                  coord.org_pointer.stato === "disattiva" && 
                  coord.org_pointer.tipo_istanza === "free"
                ).length}
                valueStyle={{ fontSize: '18px' }}
              />
            </Col>
            <Col span={8}>
              <Statistic 
                title="Demo" 
                value={orgCoords.filter(coord => 
                  coord.org_pointer.stato === "disattiva" && 
                  coord.org_pointer.tipo_istanza === "demo"
                ).length}
                valueStyle={{ fontSize: '18px' }}
              />
            </Col>
          </Row>
        </>
      )}
    </Card>
  );
};

export default StatsPanel; 